import anime from "animejs/lib/anime.es.js";

export default ({ lab }) => {
  const tl = anime.timeline({
    easing: "easeOutQuart",
  });

  tl.add({
    targets: lab,
    translateX: 93,
    duration: 500,
  });
};
